import migrationReducer from './migrationSlice';

export default function getMigrationModule() {
  return {
    id: 'migration',
    reducerMap: {
      migration: migrationReducer
    }
  };
}